// extracted by mini-css-extract-plugin
export default {"fadeBackgroundWrapper":"ajA2fQbyT4ANLB0ZByk6","right":"JTN8egqkuUDu6MNs8m0k","left":"yMUxJ2h52I7yuPlYs63N"};